import { CurrencyHelper, CurrencyPattern } from '@marketplace/myconverter';
import classNames from 'classnames';
import { memo } from 'react';

import { CURRENCY_RATIO_DEFAULT } from 'utils';
import * as styles from './styles.module.scss';
import { FormatMoneyProps } from './types';

function FormatMoney(props: FormatMoneyProps) {
  const {
    value = 0,
    unit,
    showPlus,
    afterNumber,
    variantColor,
    className,
    prefix,
    option,
  } = props;
  const unitCurrency = () => {
    if (unit && typeof unit === 'boolean') return <span>₫</span>;
    return <div className={styles.otherUnit}>{unit}</div>;
  };
  return (
    <div
      className={classNames("d-flex align-items-baseline placeholder-glow", className, styles.displayBlock, {
        'text-danger': variantColor === 'danger',
        'text-success': variantColor === 'success',
      })}
    >
      {prefix && prefix}
      {unit && unitCurrency()} {showPlus && value > 0 && '+'}
      {CurrencyHelper.doFormat(value, CurrencyPattern.BetVisualFull, {
        ratio: CURRENCY_RATIO_DEFAULT,
        symbolPosition: 'after',
        space: true,
        forceFractionZeroDigits: true,
        ...(option || {}),
      })}
      {afterNumber}
    </div>
  );
}

export default memo(FormatMoney);
